import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { IPaperInventory } from "mobx-stores/_models/paper-inventory/paper-inventory";
import { useStores } from "mobx-stores/_root-store";
import { Fragment, useCallback, useEffect, useState } from "react";
import { NumberText } from "share-components/atomics/number-text";
import { ExpandButton } from "share-components/mui-wrap/button/action-button";
import { XGroupCell } from "share-components/mui-wrap/table/x-group-cell";
import { XSubRow } from "share-components/mui-wrap/table/x-sub-row";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const PaperInventoryTable = observer(() => {
  const {
    paperInventoryManagement: {
      paperInventoryStore: {
        papersInventory,
        getPapersInventory,
        pagination,
        searchConditionAsNaturalLanguage,
      },
    },
  } = useStores();

  useEffect(() => {
    getPapersInventory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getPapersInventory();
    },
    [getPapersInventory, pagination]
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
      }}
      searchConditionAsNaturalLanguage={searchConditionAsNaturalLanguage}
    >
      <TableHead>
        <TableRow>
          <TableCell></TableCell>
          <TableCell>Mã số</TableCell>
          <TableCell>Loại giấy</TableCell>
          <TableCell>GSM</TableCell>
          <TableCell>Quy cách giấy - Dạng</TableCell>
          <TableCell>Quy cách giấy - Khổ</TableCell>
          <TableCell>Quy cách giấy - Dài</TableCell>
          <TableCell>Số lượng tồn</TableCell>
          <TableCell>Tổng nhập</TableCell>
          <TableCell>Tổng xuất</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {papersInventory.map((x, i) => (
          <Row paperInventory={x} key={x.materialId}></Row>
        ))}
      </TableBody>
    </XTablePagination>
  );
});

type RowProps = {
  paperInventory: IPaperInventory;
};
const Row = observer(({ paperInventory }: RowProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <TableRow hover>
        <TableCell sx={{ width: "30px" }}>
          <ExpandButton
            onClick={() => setOpen(!open)}
            open={open}
          ></ExpandButton>
        </TableCell>
        <TableCell>{paperInventory.material?.code || ""}</TableCell>
        <TableCell>{paperInventory.material?.type || ""}</TableCell>
        <TableCell>{paperInventory.material?.gsm || ""}</TableCell>
        <TableCell>
          {paperInventory.material?.specificationType || ""}
        </TableCell>
        <TableCell>
          <NumberText
            value={paperInventory.material?.specificationSize}
          ></NumberText>
        </TableCell>
        <TableCell>
          <NumberText
            value={paperInventory.material?.specificationLength}
          ></NumberText>
        </TableCell>
        <TableCell>
          <NumberText value={paperInventory.stock}></NumberText>
        </TableCell>
        <TableCell>
          <NumberText value={paperInventory.totalReceiptStock}></NumberText>
        </TableCell>
        <TableCell>
          <NumberText value={paperInventory.totalIssueStock}></NumberText>
        </TableCell>
      </TableRow>
      {open && (
        <XSubRow>
          <XGroupCell colSpan={10} headerTitle="Chi tiết nhập theo hiệu">
            <Table>
              <TableHead
                sx={{
                  th: {
                    zIndex: 1,
                  },
                }}
              >
                <TableRow>
                  <TableCell>Hiệu</TableCell>
                  <TableCell>Số cuồn</TableCell>
                  <TableCell>Số lượng tồn</TableCell>
                  <TableCell>Số lượng nhập</TableCell>
                  <TableCell>Số lượng xuất</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paperInventory.groupedItems &&
                  paperInventory.groupedItems.map((item, idx) => (
                    <TableRow key={item.brand}>
                      <TableCell>{item.brand || ""}</TableCell>
                      <TableCell>{item.rollNumber || ""}</TableCell>
                      <TableCell>
                        <NumberText value={item.totalStock}></NumberText>
                      </TableCell>
                      <TableCell>
                        <NumberText value={item.totalReceiptStock}></NumberText>
                      </TableCell>
                      <TableCell>
                        <NumberText value={item.totalIssueStock}></NumberText>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </XGroupCell>
        </XSubRow>
      )}
    </Fragment>
  );
});
